import { render, staticRenderFns } from "./OrderHistory.vue?vue&type=template&id=6a5d9daa"
import script from "./OrderHistory.vue?vue&type=script&lang=js"
export * from "./OrderHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports